import { createVuetify } from 'vuetify'
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'
import { VFileUpload } from 'vuetify/labs/VFileUpload'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { globalTheme } from './theme'
import { useI18n } from 'vue-i18n'
import { i18n } from './i18n'

const { themes } = globalTheme

export const vuetify = createVuetify({
  components: {
    ...components,
    VFileUpload
  },
  directives,
  theme: {
    defaultTheme: 'light',
    themes
  },
  locale: {
    adapter: createVueI18nAdapter({ i18n, useI18n })
  },
  defaults: {
    VTextField: {
      color: 'primary',
      variant: 'underlined',
      density: 'comfortable'
    },
    VTextarea: {
      color: 'primary',
      variant: 'underlined',
      density: 'comfortable'
    },
    VSelect: {
      color: 'primary',
      variant: 'underlined',
      density: 'comfortable'
    },
    VAutocomplete: {
      color: 'primary',
      variant: 'underlined',
      density: 'comfortable'
    }
  }
})
